
import {  AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { ApiServiceERP } from '../../../apis/ApiServiceERP';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormatDataTableGlobal } from 'src/app/web/util/formatDataTable';
import { ErrorService } from 'src/app/shared/services/errors.service';

export class listClient {

  id_client: number;
  name: string;
  
}


@Component({
  selector: 'app-frente-client',
  templateUrl: './create-frente-client.component.html',
  styleUrls: ['./create-frente-client.component.scss']
})
export class CreateFrenteClientComponent implements  AfterViewInit, OnDestroy, OnInit  {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  annex: any[] = []
  annexForm: FormGroup;
  step:number = 0
  title="Datos"
  createClient: listClient;
  items!: FormArray;
  paymentsform: FormGroup;
  createClientForm: FormGroup;
  idSubscription: Subscription;
  id:0;
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private apiService: ApiServiceERP,
    private errorService:ErrorService


  ) { 
    this.route.params.subscribe((params) => {
      this.id = params['id'];

    });
   
  }

  ngOnInit(): void {
    this.paymentsform = this.fb.group({
      items: new FormArray([])
    });

    this.items = this.paymentsform.get("items") as FormArray

    let info = this.fb.group({
      name: "",
    });

    this.items.push(info)


    this.spinner.show();
    this.spinner.hide();
   
   

    this.createClientForm = this.fb.group({
      id_client: [''],
      name: [''],
      
    });


    
  }
  

 
 
    ngAfterViewInit(): void {
    
  }

  ngOnDestroy(): void {
    
  }

  rerender(): void {
    
    
  }

  nuevoCampo() {
    this.items = this.paymentsform.get("items") as FormArray
    let info = this.fb.group({
      name: "",
    });

    this.items.push(info)

  }

  formSubmit(): void {
    
    if(this.createClientForm.value.name == ""){
      Swal.fire({title:"Debe selecciona un nombre" ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    this.spinner.show();


    this.createClient = this.createClientForm.value;
    this.createClient.id_client = Number(this.id);
    this.createClient.name = this.createClientForm.value.name;


   
    this.apiService.postService('client-frente-insert', this.createClient)
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();
          Swal.fire({title:'Se ha ingresado correctamente',text: '',icon: 'success',heightAuto: false})
            .then(() => [
            ]);
           this.router.navigate(['/pdg/client/frente/'+this.id]);
        },
        error: (error) => {
          this.errorService.error(error);
        }
      });
  }
}
